import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { AsYouType, isValidNumber, parseNumber, formatNumber } from 'libphonenumber-js';

import * as ɵngcc0 from '@angular/core';
class PhoneNumberFormatService {
    constructor() { }
    formatNumberAsYouType(phoneNumber, country) {
        if (/^\d+$/.test(phoneNumber[phoneNumber.length - 1])) {
            const asYouType = new AsYouType(country);
            const value = asYouType.input(phoneNumber);
            return value.length <= phoneNumber.length ? phoneNumber : value;
        }
        else {
            return phoneNumber;
        }
    }
    formatNumberInternational(phoneNumber, country, internationalFormat = true) {
        if (isValidNumber(phoneNumber, country)) {
            const parsedNumber = parseNumber(phoneNumber, country);
            if (!!parsedNumber.phone) {
                return formatNumber(parsedNumber, internationalFormat ? 'INTERNATIONAL' : 'NATIONAL');
            }
        }
        return phoneNumber;
    }
}
PhoneNumberFormatService.ɵfac = function PhoneNumberFormatService_Factory(t) { return new (t || PhoneNumberFormatService)(); };
PhoneNumberFormatService.ɵprov = i0.ɵɵdefineInjectable({ factory: function PhoneNumberFormatService_Factory() { return new PhoneNumberFormatService(); }, token: PhoneNumberFormatService, providedIn: "root" });
PhoneNumberFormatService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PhoneNumberFormatService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class PhoneNumberFormatModule {
}
PhoneNumberFormatModule.ɵfac = function PhoneNumberFormatModule_Factory(t) { return new (t || PhoneNumberFormatModule)(); };
PhoneNumberFormatModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PhoneNumberFormatModule });
PhoneNumberFormatModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [PhoneNumberFormatService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PhoneNumberFormatModule, [{
        type: NgModule,
        args: [{
                providers: [PhoneNumberFormatService]
            }]
    }], null, null); })();

/*
 * Public API Surface of phone-number-format
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PhoneNumberFormatModule, PhoneNumberFormatService };

